import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "./SectionHeader.scss";
import Icon from "core/icon/Icon";
import { Typography } from "core/typography/Typography";
import InfoContext from "pages/InfoContext";

const SectionHeader = (props) => {
  const { icon, id, defaultMessage, setSection, section, count } = props;
  const { activeSection } = useContext(InfoContext);
  const navigate = useNavigate();
  const isActive = activeSection === section;

  // `../${section}` requires the tab to be the last URL segment on every page
  // mounting a NavigationBar — see the redirect in pages/dashboard/index.js.
  const handleClick = () => {
    navigate(`../${section}`, { relative: "path", replace: isActive });
    setSection(section);
  };

  return (
    <button
      className={`section-header ${isActive ? "activeHeader" : ""}`}
      onClick={handleClick}
    >
      <div className="icon">
        {icon && <Icon color="gray-200" icon={icon} width="20" height="20" />}
      </div>
      <div className="title">
        <Typography
          className="title-4 white"
          type="p"
          label={<FormattedMessage id={id} defaultMessage={defaultMessage} />}
        />
      </div>
      {count > 0 && <span className="section-header__count">{count}</span>}
    </button>
  );
};

SectionHeader.propTypes = {
  icon: PropTypes.string,
  id: PropTypes.string,
  defaultMessage: PropTypes.string,
  setSection: PropTypes.func,
  section: PropTypes.string,
  count: PropTypes.number,
};

export default SectionHeader;
